const PopoverStore = {};

PopoverStore.callback = null;

PopoverStore.hide = function () {
  PopoverStore.register(null);
};

PopoverStore.register = function (cb) {
  if (PopoverStore.callback) {
    PopoverStore.callback();
  }
  PopoverStore.callback = cb;
};

PopoverStore.unregister = function (cb) {
  if (PopoverStore.callback === cb) {
    PopoverStore.callback = null;
  }
};

export default PopoverStore;
